import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_155: DocMigration = {
  maxSchemaVersion: "0.0.155",
  description: "Add support for new annotation line types",
  apply(json: any) {
    for (const annotationId in json.annotation) {
      const annotation = json.annotation[annotationId];

      if (annotation.type === "LINEWORK") {
        const shapes = annotation.shapes || {};

        for (const shapeId in shapes) {
          const shape = shapes[shapeId];

          shapes[shapeId] = {
            ...shape,
            lineType: shape.dashed ? "DASHED_LARGE" : "CONTINUOUS",
          };

          if (shapes[shapeId].dashed !== undefined) {
            delete shapes[shapeId].dashed;
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_155;
